import React from "react"

import {
	Button,
	DialogContent,
	DialogTitle,
	Grid,
	Typography
} from "@material-ui/core"

import {
	SerializedError
} from "@/protocols/planAddons"
import { UpsellDetails } from "@/protocols/upsell"

import useStyles from "@/components/UpsellDialog/UpsellQuantityDialog/styles"

const GENERIC_UPSELL_ERROR_MESSAGE = "O pagamento falhou. Tente novamente ou entre em contato com nosso time."

const getUpsellErrorMessage = (error: SerializedError | null): string => {
	const errorCodeToMessage: Record<string, string> = {
		Refused: "O pagamento foi recusado. Verifique os dados do cartão ou tente outro método de pagamento.",
		Chargeback: "O pagamento sofreu um chargeback. Entre em contato com nosso time para regularizar.",
		NotPayedLate: "O pagamento não foi concluído dentro do prazo. Tente novamente."
	}

	if (!error?.errorCode) {
		return GENERIC_UPSELL_ERROR_MESSAGE
	}

	return errorCodeToMessage[error.errorCode] ?? GENERIC_UPSELL_ERROR_MESSAGE
}

type UpsellQuantityDialogFailedContentProps = {
	upsellDetails: UpsellDetails
	onRetryClick: () => void
	onContactSupportClick: () => void
}

const UpsellQuantityDialogFailedContent: React.FC<UpsellQuantityDialogFailedContentProps> = (props) => {
	const {
		upsellDetails,
		onRetryClick,
		onContactSupportClick
	} = props

	const classes = useStyles()

	return (
		<Grid
			container
			direction="column"
			className={classes.fullDialog}
		>
			<Grid
				item
			>
				<DialogTitle>
					<Grid
						container
						direction="column"
						spacing={2}
					>
						<Grid
							item
						>
							<Typography variant="h3" className={classes.dialogTitle}>
								Erro no pagamento
							</Typography>
						</Grid>
					</Grid>
				</DialogTitle>
			</Grid>
			<Grid
				item
			>
				<DialogContent className={classes.dialogContent}>
					<Grid
						container
						direction="column"
						spacing={4}
					>
						<Grid item>
							<Typography className={classes.dialogDescription}>
								{getUpsellErrorMessage(upsellDetails.error)} Entre em contato com nosso time pelo WhatsApp para concluir a contratação.
							</Typography>
						</Grid>
						<Grid item>
							<Grid container spacing={2}>
								<Grid item xs={10}>
									<Button
										variant="contained"
										className={classes.dialogActionPrimaryButton}
										onClick={onContactSupportClick}
										fullWidth
									>
										Falar com especialista
									</Button>
								</Grid>
								<Grid item xs={10}>
									<Button
										variant="text"
										className={classes.dialogActionSecondaryButton}
										onClick={onRetryClick}
										fullWidth
									>
										Tentar novamente
									</Button>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</DialogContent>
			</Grid>
		</Grid>
	)
}

export default UpsellQuantityDialogFailedContent
